module.exports = __webpack_public_path__ + "img/hondafit.2904068b.png";